module.exports = __webpack_public_path__ + "img/item3.d334bd71.png";